import React, { useEffect, useState } from 'react';

import {
  CRITERIA_COMPLEMENTARY_TYPE,
  CRITERIA_SPIKE_TYPE,
  CRITERIA_TYPE,
} from '../../../../../../../../utils/constants';
import * as styles from './criteria-summary.module.scss';
import { CriteriaSummaryCustomTable, CustomSelect } from './styled';

const MatchingCriteriaSummary = (props) => {
  const { currentSetDetail } = props;

  const [listRanking, setListRanking] = useState([]);
  const [rankOptions, setRankOptions] = useState([]);

  useEffect(() => {
    if (currentSetDetail?.ranking_criteria) {
      setListRanking(currentSetDetail?.ranking_criteria.filter((item) => item.rank !== 0));
    }
  }, [currentSetDetail]);

  const SHOW_CRITERIA_NAME_MAP = {
    [CRITERIA_SPIKE_TYPE.EDGE_SPIKE]: 'EDGE Spike',
    [CRITERIA_SPIKE_TYPE.ATTRIBUTES_SPIKE]: 'Attributes Spike',
    [CRITERIA_SPIKE_TYPE.BUSINESS_EXPOSURE_SPIKE]: 'Business Exposure Spike',
  };

  const SHOW_CRITERIA_MAP_COMPLEMENTARY_NAME = {
    [CRITERIA_COMPLEMENTARY_TYPE.FUNCTIONAL_MANDATORY]:
      CRITERIA_COMPLEMENTARY_TYPE.FUNCTIONAL_MANDATORY,
    [CRITERIA_COMPLEMENTARY_TYPE.FUNCTIONAL_OPTIONAL]:
      CRITERIA_COMPLEMENTARY_TYPE.FUNCTIONAL_OPTIONAL,
    [CRITERIA_COMPLEMENTARY_TYPE.FUNCTIONAL_SPIKE]: CRITERIA_COMPLEMENTARY_TYPE.FUNCTIONAL_SPIKE,
  };

  const replaceSpikeOrComplementary = (value) => {
    if (Object.values(CRITERIA_SPIKE_TYPE).includes(value)) {
      return SHOW_CRITERIA_NAME_MAP[value];
    } else if (Object.values(CRITERIA_COMPLEMENTARY_TYPE).includes(value)) {
      return SHOW_CRITERIA_MAP_COMPLEMENTARY_NAME[value];
    } else {
      return value;
    }
  };

  const columns = [
    {
      title: 'Criteria',
      dataIndex: 'criteria',
      width: '30%',
      render: (value) => (
        <div>
          <div>{replaceSpikeOrComplementary(value)}</div>
        </div>
      ),
    },
    {
      title: 'Ranking',
      width: '40%',
      align: 'center',
      render: (item, _, index) => (
        <>
          {item.rank !== 0 &&
            currentSetDetail?.ranking_criteria.map((i) => i.criteria).includes(item.criteria) && (
              <div>
                <CustomSelect
                  disabled={true}
                  data-testid="rank-select"
                  size="middle"
                  value={item.rank}
                  placeholder="Select"
                  virtual={false}
                  style={{ width: 220 }}
                  options={rankOptions.map((item) => ({ label: item, value: item }))}
                />
              </div>
            )}
        </>
      ),
    },
  ];

  useEffect(() => {
    setRankOptions(
      Array.apply(null, Array(listRanking.length)).map(function (x, i) {
        return i + 1;
      })
    );
  }, [listRanking]);

  return (
    <div className={styles.wrapper}>
      <div className="d-flex justify-content-between">
        <h4 className={styles.title}>Summary</h4>
      </div>
      <CriteriaSummaryCustomTable
        columns={columns}
        dataSource={currentSetDetail?.ranking_criteria}
        pagination={false}
        rowKey={'criteria'}
      />
    </div>
  );
};

export default MatchingCriteriaSummary;
